<template>
    <div>
        <div class="sm:py-8 py-4">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>
</template>
